import styled from "styled-components"
import {
    SelectDropdown,
    Button,
} from "client/components"

export const SetDataWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    & > ${Button} {
        margin-bottom: 0;
    }
`
export const SetName = styled.div`
    display: flex;
    width: 30%;
    margin-right: 50px;
    padding: 10px 0;

    i {
        display: flex;
        align-items: center;
        margin-left: 10px;
        opacity: 0;
        color: lightgrey;
        transition: opacity ${(props) => props.theme.defaultTransition};
    }

    &:hover {
        i {
            opacity: 1;
            transition: opacity ${(props) => props.theme.defaultTransition};
        }
    }
`
export const SelectDropdownStyled = styled(SelectDropdown)`
    width: 10%;

    & > .btn, & > .btn:active, & > .btn:focus, & > .btn:active:focus {
        background: ${(props) => props.theme.tableSectionMinorDropdownBackground} !important;
        color: ${(props) => props.theme.tableSectionMinorDropdownColor};

        &::after {
            border-top: 4px solid ${(props) => props.theme.tableSectionMinorDropdownColor};
        }
    }
`
export const CopyButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    justify-content: end;
`
export const CopyButton = styled.div`
    height: 38px;
    width: 50px;
    font-size: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const ConfirmTable = styled.table`
    margin-bottom: 10px;

    & tr td {
        padding: 8px;

        &:first-child {
            width: 40%;
        }
    }

    & ${Button} {
        width: 100%;
        min-height: 38px;
        height: fit-content;
        padding: 8px 15px;
        white-space: normal;
        text-align: center;
    }
`
